export function LetterVariant({ letter }: Readonly<{ letter: string }>) {
    return <span className='has-variant'>{letter}</span>;
}
